import UserCertificationItemAdditionalCheckInfo from './UserCertificationItemAdditionalCheckInfo';
import ProfilePictureItemGrid from '@/components/custom/ProfilePictureItemGrid.tsx';
import UserCertificationItemUserInfos from './UserCertificationItemUserInfos';
import ProfileBottomStats from '@/components/custom/ProfileBottomStats..tsx';
import UserCertificationItemFooter from './UserCertificationItemFooter';
import UserCertificationItemPhoto from './UserCertificationItemPhoto';
import UserCertificationItemInfos from './UserCertificationItemInfos';
import BadgeUserAccountStatus from '../BadgeUserAccountStatus';
import type { ICertifications } from '@/lib/interface.ts';
import { Card } from '@/components/ui/card.tsx';
import { UserAccountStatusEnum } from '@/enums';
import { cn } from '@/lib/utils.ts';

type TProps = {
	onClick?: (item: ICertifications, accept: boolean) => void;
	deniedStateChange?: boolean;
	item: ICertifications;
	readonly?: boolean;
	className?: string;
	removeItemLocally?: (userId: string) => void;
	disableActionInvalidations?: boolean;
};

const UserCertificationItem = ({
	item,
	readonly = false,
	onClick,
	className,
	deniedStateChange,
	removeItemLocally,
	disableActionInvalidations
}: TProps) => (
	<Card className={cn('flex flex-col space-y-3 pb-4 relative', 'md:mx-0', 'animate__animated animate__fadeIn', className)}>
		<div className="flex flex-col mx-auto">
			<UserCertificationItemPhoto certification={item} />
			<UserCertificationItemUserInfos
				certification={item}
				removeItemLocally={removeItemLocally}
				disableActionInvalidations={disableActionInvalidations}
				className="py-2" />
			<UserCertificationItemAdditionalCheckInfo certification={item} />
		</div>
		<div className={'flex flex-col items-center space-y-3'}>
			<ProfileBottomStats hideTitle hideCoins userId={item?.userData?._id} deviceBanCount={item?.userData?.deviceBanCount} />
			<ProfilePictureItemGrid
				readonly={readonly}
				userId={item?.userData?._id}
				pictures={item?.userData?.pictures}
				imageContainerClassName={'md:w-28'}
			/>
		</div>
		<UserCertificationItemInfos certification={item} readonly={readonly} />
		{!readonly && <UserCertificationItemFooter deniedStateChange={deniedStateChange} certification={item} onClick={onClick} removeItemLocally={removeItemLocally} />}
		<BadgeUserAccountStatus
			user={item.userData}
			title="Cet utilisateur est inactif"
			isVisible={l => l.accountStatus !== UserAccountStatusEnum.ACTIVE}
			className={'text-nowrap px-2 py-0.5 text-xs rounded-sm absolute -top-5 -right-1'}
		/>
	</Card>
);

export default UserCertificationItem;
